import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgbOffcanvas, NgbOffcanvasOptions, NgbOffcanvasRef } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { UsersAdminService } from '../../services/users-admin.service';
import { filter, map, switchMap, tap } from 'rxjs';
import { UserRolesSlideoutComponent } from './user-roles-slideout/user-roles-slideout.component';

@Component({
    selector: 'app-user-roles-slideout-wrapper',
    template: '',
    standalone: false
})
export class UserRolesSlideoutWrapperComponent implements OnInit, OnDestroy {
  slideoutOptions: NgbOffcanvasOptions = {
    backdrop: false,
    animation: true,
    ariaLabelledBy: 'user-roles-slideout',
    position: 'end',
    scroll: true,
  };

  private slideoutRef!: NgbOffcanvasRef;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private usersAdminService: UsersAdminService,
              protected slideoutService: NgbOffcanvas) { }

  ngOnInit() {
    this.slideoutRef = this.slideoutService.open(UserRolesSlideoutComponent, this.slideoutOptions);
    const slideoutComponent = this.slideoutRef.componentInstance as UserRolesSlideoutComponent;

    this.route.paramMap
      .pipe(
        tap(() => { slideoutComponent.loading = true; }),
        map(params => params.get('userId')),
        filter(userId => userId != null),
        switchMap(userId => this.usersAdminService.getUser(userId!)))
      .subscribe(user => {
        slideoutComponent.user = user;
        slideoutComponent.loading = false;
      })

    this.slideoutRef.result.then(
      () => {
        // when closed, navigate back to the user list
        this.router.navigate(['../..'], { relativeTo: this.route }).then();
      },
      // when dismissed, do not change the route, as the user must have navigated somewhere themselves
      () => {}
    )
  }

  ngOnDestroy() {
    this.slideoutRef.dismiss();
  }
}
